import PropTypes from "prop-types";
import React, { Component } from "react";

class Dashboard extends Component {
    constructor() {
        super();
    }

    render() {

        return (
            <div />
        );
    }
}

Dashboard.propTypes = {
    isFetchingTimeLogs: PropTypes.bool.isRequired,
    getCaseTimeLogByUserPayPeriod: PropTypes.func.isRequired,
};

export default Dashboard;